import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { LoaderIcon } from "react-hot-toast";
import IcdCode from "./components/IcdCode";
import PbmAcdDetails from "./components/response/PbmAcdDetails";
import ItemCodesSearchNSelect from "./components/request/ItemCodesSearchNSelect";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../shared/CustomFilterInput";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Service types array defined once
const serviceTypes = [
  { id: "medical-devices", name: "Medical Devices" },
  { id: "medication-codes", name: "Medication Codes" },
  { id: "transportation-srca", name: "Transportation SRCA" },
  { id: "imaging", name: "Imaging" },
  { id: "services", name: "Services" },
  { id: "laboratory", name: "Laboratory" },
  { id: "oral-health-op", name: "Oral Health OP" },
  { id: "procedures", name: "Procedures" },
];

function PreAuthPbmModal({ setOpen, open }) {
  const [t, i18n] = useTranslation();
  const [acdItems, setAcdItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dropDownItems, setDropDownItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState({});
  const [serviceType, setServiceType] = useState("");
  const [serviceCode, setServiceCode] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const handleServiceTypeChange = (e) => {
    const selectedType = e.target.value;
    console.log(selectedType);

    setServiceType(selectedType);
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{ zIndex: 100 }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar sx={{ background: "#0070C2" }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {t("Pre Authorization PBM")}
            </Typography>
            <Button
              size="small"
              autoFocus
              color="inherit"
              onClick={handleClose}
            >
              {t("Close")}
            </Button>
          </Toolbar>
        </AppBar>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-end lg:grid-cols-4 p-2">
          <div className="flex flex-col gap-1">
            <label htmlFor="select-type" className="text-[12px] font-medium">
              {t("Icd Code")}{" "}
            </label>
            <IcdCode
              setAcdItems={setAcdItems}
              setLoading={setLoading}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              serviceType={serviceType}
              serviceCode={serviceCode}
              loading={loading}
            />
          </div>
          <div className="flex flex-col gap-1">
            <CustomFilterInput
              label={t("Select Type*")}
              name="type"
              onChange={handleServiceTypeChange}
              id="select-type"
              value={serviceType}
              isSelect={true}
              options={serviceTypes}
              placeholder={t("Select Type*")}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="search-code" className="text-sm font-medium">
              {t("Search for Code")}
            </label>
            <ItemCodesSearchNSelect
              typeName={serviceType}
              setFieldValue={setServiceCode}
              id="search-code"
            />
          </div>
        </div>
        {console.log(serviceCode, serviceType)}
        <div className="p-3">
          {loading ? (
            <div className="flex w-full justify-center items-center py-8">
              <LoaderIcon className="h-8 w-8 text-amber-500" />
            </div>
          ) : acdItems ? (
            <PbmAcdDetails item={acdItems} />
          ) : (
            <div className="flex w-full justify-center items-center py-8">
              <Typography variant="body1" color="text.secondary">
                {t("No Available Data")}
              </Typography>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}

export default PreAuthPbmModal;
